// extracted by mini-css-extract-plugin
module.exports = {"pinterestShare":"src-components-Share-Pinterest-styles-style-module__pinterestShare--3ZaCR"};